var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.683 13.962L9.20495 12.5677C9.07895 12.4805 8.95295 12.4805 8.82695 12.5677L6.39095 13.9184C6.09695 14.0927 5.76094 13.8313 5.80294 13.4827L6.26495 10.6505C6.30695 10.5198 6.26495 10.3891 6.13895 10.3019L4.12294 8.21044C3.87094 7.94901 4.03894 7.55687 4.33294 7.5133L7.18895 7.12114C7.31495 7.12114 7.44095 6.99043 7.48295 6.85971L8.57495 4.24537C8.70095 3.94036 9.16295 3.89679 9.28895 4.24537L10.507 6.85971C10.549 6.99043 10.675 7.07757 10.801 7.07757L13.657 7.46972C13.993 7.51329 14.119 7.94902 13.867 8.16688L11.851 10.2583C11.767 10.3455 11.725 10.4762 11.725 10.6069L12.103 13.4827C12.313 13.8749 11.977 14.0927 11.683 13.962Z",
    fill: "#006CFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationFormula);
export default __webpack_public_path__ + "static/media/celebration-formula.0b1e9c634c4f0d295f8febce233bad97.svg";
export { ForwardRef as ReactComponent };